import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const ReportsDocsAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
